import React, { Component } from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Route, Switch } from "react-router-dom";
import Navbar from "./components/Navbar";
import ProductList from "./components/ProductList";
import Details from "./components/Details";
import Default from "./components/Default";
import Cart from "./components/Cart";
import Modal from "./components/Modal";

import Modal2 from "./components/Modal2";
import Add from "./components/Add";
import checkout from "./components/checkout";
import transactionl from "./components/TransactionsL"
import paymentl from "./components/PaymentL";
import Reciept from "./components/Reciept";
class App extends Component {
  render() {
    return (
      <React.Fragment>
        <Navbar />
        <Switch>
          <Route exact path="/" component={ProductList} />
          <Route path="/details" component={Details} />
          <Route path="/cart" component={Cart} />
          <Route path="/Add" component={Add} />
          <Route path="/transactionl" component={transactionl} />
          <Route path="/paymentl" component={paymentl} />
          <Route path="/Reciept/:id" component={Reciept} />
          <Route path='/checkout/:id' component={checkout} />
          <Route component={Default} />
        </Switch>
        <Modal />
        <Modal2 />
      </React.Fragment>
    );
  }
}

export default App;